import React from 'react'
import PropTypes from 'prop-types';

const Header = props => (<header id="header" style={props.timeout
    ? {
      display: 'none'
    }
    : {}}>
  <div className="logo">
    <span className="icon fa-rocket"/>
  </div>
  <div className="content">
    <div className="inner">
      <h1>Moons of Saturn</h1>

      <p>
        The moons of Saturn are numerous and diverse, ranging from tiny moonlets less than 1 kilometer across to the enormous Titan, which is larger than the planet Mercury. Saturn has 62 moons with confirmed orbits, 53 of which have names and only 13 of which have diameters larger than 50 kilometers, as well as dense rings with complex orbital motions of their own.
      </p>
    </div>
  </div>
  <nav>
    <ul>
      <li>
        <a href="javascript:;" onClick={() => {
            props.onOpenArticle('intro')
          }}>
          Video.React
        </a>
      </li>
      <li>
        <a href="javascript:;" onClick={() => {
            props.onOpenArticle('work')
          }}>
          Ed Ward
        </a>
      </li>
      <li>
        <a href="javascript:;" onClick={() => {
            props.onOpenArticle('about')
          }}>
          About
        </a>
      </li>
      <li>
        <a href="javascript:;" onClick={() => {
            props.onOpenArticle('contact')
          }}>
          Contact
        </a>
      </li>
    </ul>
  </nav>
</header>)
Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js